import React, { useEffect, useRef, useState } from "react";
import {
  Nav,
  Navbar,
  NavDropdown,
  Modal,
  Container,
  Row,
  Card,
  Col,
  Button,
} from "react-bootstrap";
import Clock from "./CommonServices/LiveClock";
import { AiOutlineForm, AiFillLock, AiOutlineLogout } from "react-icons/ai";
import {
  BsHouseFill,
  BsFillBarChartFill,
  BsGraphUp,
  BsLightningChargeFill,
} from "react-icons/bs";
import { GiAlarmClock } from "react-icons/gi";
import SwaranandhraService from "../Services/SwaranandhraService";
import { useNavigate } from "react-router-dom";
import { RxLapTimer } from "react-icons/rx";
import Footer from "../Footer";
import useAlert from "./Alert/useAlert";
import AlertModal from "./Alert/AlertModal";
import { FaCircle, FaHandPointRight, FaStar, FaTimes } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { FaArrowRightLong, FaCircleUser } from "react-icons/fa6";
import {
  TbDeviceAnalytics,
  TbRosetteNumber1,
  TbRosetteNumber2,
  TbRosetteNumber3,
  TbRosetteNumber4,
} from "react-icons/tb";
import DesService from "../Services/Des Service";
import { Button as MuiButton } from "@mui/material";
import {
  MdMiscellaneousServices,
  MdOutlineAutoGraph,
  MdOutlineSecurity,
  MdSwapHoriz,
} from "react-icons/md";
import Menubar from "./Menubar";
import Dashboard from "./Dashboard";
// import { LOGIN_DOMAIN, PLANNING_DOMAIN } from "../Services/Configuration";
import { FcAlarmClock } from "react-icons/fc";
import { FiPower } from "react-icons/fi";
import { IoLogOutOutline } from "react-icons/io5";
import { MdCampaign } from "react-icons/md";
import NotificationBanner from "./NotificationBanner";
import axiosTokenService from "../Services/axiosTokenService";
import { VscFeedback } from "react-icons/vsc";
import { RiUserStarLine } from "react-icons/ri";
// import { file_pwd, portal_pwd } from "./utils/commonFunctions";

export default function Header() {
  let username = localStorage.getItem("username");
  let Passwd = localStorage.getItem("Passwd");
  let userType = localStorage.getItem("userType");
  let roleid = localStorage.getItem("role");
  let catid = localStorage.getItem("catid");

  const location = useLocation();
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [countdown, setCountdown] = useState(() => {
    const savedCountdown = localStorage.getItem("countdown");
    return savedCountdown ? parseInt(savedCountdown, 10) : 2400;
  });

  const [showDashboardImage, setShowDashboardImage] = useState(false);

  const [flippedCard, setFlippedCard] = useState(null);
  const [moduleList, setModulelist] = useState([]);
  const [submoduleList, setsubModulelist] = useState([]);

  const SubId = localStorage.getItem("subId");
  let psswdDays = localStorage.getItem("psswdDays");
  const [subId, setSubId] = useState(SubId);
  const token = localStorage.getItem("token");

  useEffect(() => {
    let modulelist = JSON.parse(localStorage.getItem("Module"))?.map(
      (item, i) => {
        let correspondingItem = JSON.parse(
          localStorage.getItem("SubModule"),
        )?.filter((secondItem) => secondItem.module_id === item.module_id);
        return { ...item, submoduleList: correspondingItem };
      },
    );

    setModulelist(modulelist);
    setsubModulelist(JSON.parse(localStorage.getItem("SubModule")));
    console.log("submodule", JSON.parse(localStorage.getItem("SubModule")));
  }, []);

  // useEffect(() => {
  //     const fetchData = async () => {
  //       try {
  //         const response = await axiosTokenService.get("/api/your-endpoint");
  //         console.log("API Response:", response.data);
  //       } catch (error) {
  //         console.error("API Error:", error);
  //       }
  //     };

  //     fetchData();

  //     // const intervalId = setInterval(fetchData, 15 * 60 * 1000);
  //     const intervalId = setInterval(fetchData, 5000);

  //     return () => clearInterval(intervalId);
  //   }, []);

  const [SubmoduleServices, setSubmoduleServices] = useState([]);

  useEffect(() => {
    let menu = JSON.parse(localStorage.getItem("Menu"));
    let submodmenu = JSON.parse(localStorage.getItem("Subdata"));
    setEntryFormServices(menu);
    setSubmoduleServices(submodmenu);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const [marqueeMessages, setMarqueeMessages] = useState([]);

  // const [pausedIndex, setPausedIndex] = useState(null);
  //   const [wiggleIndex, setWiggleIndex] = useState(null);
  //   const [labelExpanded, setLabelExpanded] = useState(false);

  //   const marqueeRef = useRef(null);
  //   const isDragging = useRef(false);
  //   const startX = useRef(0);
  //   const scrollLeft = useRef(0);

  //   const handleDragStart = (e) => {
  //     isDragging.current = true;
  //     const clientX = e.touches ? e.touches[0].clientX : e.clientX;
  //     startX.current = clientX - marqueeRef.current.offsetLeft;
  //     scrollLeft.current = marqueeRef.current.scrollLeft;
  //     marqueeRef.current.style.cursor = "grabbing";
  //   };

  //   const handleDragging = (e) => {
  //     if (!isDragging.current) return;
  //     e.preventDefault();
  //     const clientX = e.touches ? e.touches[0].clientX : e.clientX;
  //     const x = clientX - marqueeRef.current.offsetLeft;
  //     marqueeRef.current.scrollLeft = scrollLeft.current - (x - startX.current);
  //   };

  //   const handleDragEnd = () => {
  //     isDragging.current = false;
  //     if (marqueeRef.current) marqueeRef.current.style.cursor = "grab";
  //   };

  useEffect(() => {
    //   localStorage.setItem("showNotificationBanner","true");
    // localStorage.setItem("marqueeList", JSON.stringify([
    //   {
    //     subject: "Achievement Data Forwarded for Review - Kothuru Mandal | FY 2025-26 | Quarterly - Q1 (Apr - Jun)",
    //     subjectDesc: "Achievement data for Kothuru Mandal for the financial year 2025-26 and Quarterly periodicity (Q1 (Apr - Jun)) has been forwarded to District Officer for review and further processing.",
    //   dept_notification_files:'1781593130765_Planningentry.pdf'
    //   },
    //   {
    //     subject: "Achievement Data Approved - Srikakulam Mandal | FY 2026-27 | Monthly - MAY",
    //     subjectDesc: "Achievement data for Srikakulam Mandal the financial year 2026-27 and Monthly periodicity (MAY) has been approved by the concerned authority."
    //   }
    // ]));
  }, []);
  const handleProfileClick = () => {
    window.location.href = "/userprofile";
  };

  const renderSubModuleMenu = (subMenu) => {
    return (
      <NavDropdown style={{ width: "400px" }}>
        {subMenu.subchilds.map((subItem, subIndex) => (
          <NavDropdown.Item key={subIndex} href={subItem.subchild_targeturl}>
            {subItem.subchild_menuitemname}
          </NavDropdown.Item>
        ))}
        <NavDropdown.Divider />
      </NavDropdown>
    );
  };
  const [renderKey, setRenderKey] = useState(0);

  useEffect(() => {
    fetchData().then(() => {
      setRenderKey((prevKey) => prevKey + 1);
    });
  }, []);

  // if (user === "" || user === undefined || user === null) {
  //   Swal.fire({
  //     text: "Session Expired",
  //     icon: "success",
  //     confirmButtonText: "Ok",
  //     confirmButtonClass: "swal-button--confirm",
  //   }).then(function () {
  //     window.location = LOGIN_DOMAIN;
  //   });
  // } else {
  // }

  const [ModEnb, setModEnb] = useState(true);
  const [Id, setId] = useState(null);

  useEffect(() => {
    if (location.pathname === "/Menubar") {
      setModEnb(true);
    } else {
      setModEnb(false);
    }
  }, [location.pathname]);

  // const Modulelogin = (id) => {

  //   setId(id);
  //   if (id === "1") {
  //     let params = {
  //       token: localStorage.getItem("token"),
  //     };

  //     SwaranandhraService.userLogout(params).then(() => {
  //       console.log("User logged out successfully.");
  // localStorage.clear()
  //       // Open the new tab
  //       const newTab = window.open(PLANNING_DOMAIN+"Menubar", "_blank");

  //       if (newTab) {
  //         console.log("New tab opened.");

  //         // Handshake listener to detect readiness
  //         const handshakeListener = (event) => {
  //           console.log("Received handshake:", event);

  //           // Validate the origin
  //           if (event.origin === PLANNING_DOMAIN && event.data === "READY") {
  //             console.log("Handshake confirmed. Sending credentials...");

  //             // Send the credentials only after handshake
  //             newTab.postMessage(
  //               {
  //                 username: username,
  //                 password: Passwd,
  //                 origin: LOGIN_DOMAIN,
  //               },
  //               PLANNING_DOMAIN
  //             );

  //             // Close the current tab (3001)
  //             window.open("about:blank", "_self");
  //             window.close();

  //             // Clean up the listener
  //             window.removeEventListener("message", handshakeListener);
  //           }
  //         };

  //         // Listen for handshake message
  //         window.addEventListener("message", handshakeListener);
  //       } else {
  //         console.error("Failed to open new tab. Please allow pop-ups.");
  //       }
  //     });
  //   }

  //   // if(id==="1"){
  //   //   // const planningWindow = window.open(PLANNING_DOMAIN, "_blank");

  //   //   // window.addEventListener("message", (event) => {
  //   //   //   if (event.origin === PLANNING_DOMAIN) {
  //   //   //     event.source.postMessage({ username, password: Passwd }, PLANNING_DOMAIN);
  //   //   //   }
  //   //   // });

  //   //   // const sendData = () => {
  //   //   //   const data ={ username, password: Passwd };
  //   //   //   localStorage.setItem("sharedData", JSON.stringify(data));
  //   //   // };
  //   //   // sendData();
  //   //   let params = {
  //   //     token: localStorage.getItem("token"),
  //   //   };

  //   //   SwaranandhraService.userLogout(params).then(() => {
  //   //     window.location.href=PLANNING_DOMAIN
  //   //     let params = { "username":username, "password": Passwd, "capchaId": "ABCDE"}
  //   //     SwaranandhraService.planninglogin(params).then((response) => {})

  //   //   });

  //   // }
  //   else{

  //   let params = {
  //     userId: localStorage.getItem("username"),
  //     roleId: localStorage.getItem("role"),
  //     subModuleId: id,
  //     token: localStorage.getItem("token"),
  //   };

  //   DesService.getModuleData(params).then((res) => {
  //     localStorage.setItem("subId", id);
  //     localStorage.setItem("Subdata", JSON.stringify(res?.data?.SDESC));

  //     localStorage.setItem("pendingMsgForGMDP", res?.data?.pendingMsgForGMDPContributions);
  //     localStorage.setItem("dashboardStatusForTA_GMDP", JSON.stringify(res?.data?.dashboardStatusForTA_GMDP));
  //     localStorage.setItem("approved", res?.data?.dashboardStatusForTA_GMDP?.approved_t_a);
  //     localStorage.setItem("pending_at_cpo", res?.data?.dashboardStatusForTA_GMDP?.pending_at_cpo_t_a);
  //     localStorage.setItem("mandal_total_count", res?.data?.dashboardStatusForTA_GMDP?.mandal_total_count);
  //     localStorage.setItem("pending_at_aso", res?.data?.dashboardStatusForTA_GMDP?.pending_at_aso_t_a);
  //     localStorage.setItem("pending_at_ad", res?.data?.dashboardStatusForTA_GMDP?.pending_at_ad_t_a);
  //     localStorage.setItem("to_bestart_aso_t_a", res?.data?.dashboardStatusForTA_GMDP?.to_bestart_aso_t_a);
  //     localStorage.setItem("dashboardStatusForTA_GMDP", JSON.stringify(res?.data?.dashboardStatusAtASO));
  //     localStorage.setItem("aso_approved", res?.data?.dashboardStatusAtASO?.approved_t_a);
  //     localStorage.setItem("aso_pending_at_cpo", res?.data?.dashboardStatusAtASO?.pending_at_cpo_t_a);
  //     localStorage.setItem("aso_mandal_total_count", res?.data?.dashboardStatusAtASO?.mandal_total_count);
  //     localStorage.setItem("aso_pending_at_aso", res?.data?.dashboardStatusAtASO?.pending_at_aso_t_a);
  //     localStorage.setItem("aso_pending_at_ad", res?.data?.dashboardStatusAtASO?.pending_at_ad_t_a);
  //     localStorage.setItem("aso_to_bestart_aso_t_a", res?.data?.dashboardStatusAtASO?.to_bestart_aso_t_a);

  //     // kpi dashboard counts
  //     //mandal officer
  //     if(res?.data?.SDESC?.roleid == "31"){
  //       console.log("roleid",res?.data?.SDESC?.roleid)
  //     localStorage.setItem("pending_at_mandal_officer_t_a", res?.data?.mandalLevelDashboardStatusAtASOLevel?.pending_at_mandal_officer_t_a);
  //     localStorage.setItem("pending_at_district_officer_t_a", res?.data?.mandalLevelDashboardStatusAtASOLevel?.pending_at_district_officer_t_a);
  //     localStorage.setItem("to_bestart_mandal_officer_t_a", res?.data?.mandalLevelDashboardStatusAtASOLevel?.to_bestart_mandal_officer_t_a);
  //     localStorage.setItem("pending_at_hod_officer_t_a", res?.data?.mandalLevelDashboardStatusAtASOLevel?.pending_at_hod_officer_t_a);
  //     localStorage.setItem("approved_t_a", res?.data?.mandalLevelDashboardStatusAtASOLevel?.approved_t_a);
  //     }
  //     //DISTRICT oFFICER
  //     if(res?.data?.SDESC?.roleid == "32"){
  //       console.log("roleid",res?.data?.SDESC?.roleid)
  //     localStorage.setItem("mandal_total_count", res?.data?.mandalLevelDashboardStatusAtCpoLevel?.mandal_total_count);
  //     localStorage.setItem("pending_at_mandal_officer_t_a", res?.data?.mandalLevelDashboardStatusAtCpoLevel?.pending_at_mandal_officer_t_a);
  //     localStorage.setItem("pending_at_district_officer_t_a", res?.data?.mandalLevelDashboardStatusAtCpoLevel?.pending_at_district_officer_t_a);
  //     localStorage.setItem("to_bestart_mandal_officer_t_a", res?.data?.mandalLevelDashboardStatusAtCpoLevel?.to_bestart_mandal_officer_t_a);
  //     localStorage.setItem("pending_at_hod_officer_t_a", res?.data?.mandalLevelDashboardStatusAtCpoLevel?.pending_at_hod_officer_t_a);
  //     localStorage.setItem("approved_t_a", res?.data?.mandalLevelDashboardStatusAtCpoLevel?.approved_t_a);

  //     localStorage.setItem("dist_pending_at_district_officer_t_a", res?.data?.districtLevelDashboardStatusAtCpoLevel?.pending_at_district_officer_t_a);
  //     localStorage.setItem("dist_to_bestart_district_officer_t_a", res?.data?.districtLevelDashboardStatusAtCpoLevel?.to_bestart_district_officer_t_a);
  //     localStorage.setItem("dist_pending_at_hod_officer_t_a", res?.data?.districtLevelDashboardStatusAtCpoLevel?.pending_at_hod_officer_t_a);
  //     localStorage.setItem("dist_approved_t_a", res?.data?.districtLevelDashboardStatusAtCpoLevel?.approved_t_a);
  //     }
  //     // Hod officer
  //     if(res?.data?.SDESC?.roleid == "60"){
  //       console.log("roleid",res?.data?.SDESC?.roleid)
  //     localStorage.setItem("mandal_total_districts", res?.data?.mandalLevelDashboardStatusAtHodLevel?.total_districts);
  //     localStorage.setItem("mandal_not_started_districts", res?.data?.mandalLevelDashboardStatusAtHodLevel?.not_started_districts);
  //     localStorage.setItem("mandal_started_districts", res?.data?.mandalLevelDashboardStatusAtHodLevel?.started_districts);

  //     localStorage.setItem("dist_total_districts", res?.data?.districtLevelDashboardStatusAtHodLevel?.total_districts);
  //     localStorage.setItem("dist_not_started_districts", res?.data?.districtLevelDashboardStatusAtHodLevel?.not_started_districts);
  //     localStorage.setItem("dist_started_districts", res?.data?.districtLevelDashboardStatusAtHodLevel?.started_districts);

  //     localStorage.setItem("hod_to_bestart_hod_officer_t_a", res?.data?.hodLevelDashboardStatusAtHodLevel?.to_bestart_hod_officer_t_a);
  //     localStorage.setItem("hod_pending_at_hod_t_a", res?.data?.hodLevelDashboardStatusAtHodLevel?.pending_at_hod_t_a);
  //     localStorage.setItem("hod_approved_t_a", res?.data?.hodLevelDashboardStatusAtHodLevel?.approved_t_a);
  //     }
  //     setSubmoduleServices(res?.data?.SDESC);
  //     setModEnb(false);
  //   });
  // }};

  let nodelOfficerMapService = localStorage.getItem("nodelOfficerMapService");

  const getNotifications = () => {
    let params = {
      userId: localStorage.getItem("username"),
    };

    DesService.getNotifications(params).then((res) => {
      if (res.data?.SCODE === "01") {
        if (res.data?.SDESC?.length > 0) {
          localStorage.setItem("showNotificationBanner", "true");

          const marqueeList = res.data.SDESC.map((item) => ({
            subject: item.subject,
            subjectDesc: item.subject_desc,
            dept_notification_files: item.dept_notification_files,
          }));

          setMarqueeMessages(marqueeList);
          localStorage.setItem("marqueeList", JSON.stringify(marqueeList));
        } else {
          setMarqueeMessages([]);
          localStorage.setItem("showNotificationBanner", "false");
          localStorage.removeItem("marqueeList");
        }
      } else {
        setMarqueeMessages([]);
        localStorage.setItem("showNotificationBanner", "false");
        localStorage.removeItem("marqueeList");
      }
    });
  };
  useEffect(() => {
    // getNotifications(); // initial call
    if (localStorage.getItem("Moduleid") === "3") {
      const interval = setInterval(
        () => {
          getNotifications();
        },
        15 * 60 * 1000,
      );
      // }, 10000);

      return () => clearInterval(interval);
    }
  }, []);
  const Modulelogin = (id) => {
    localStorage.setItem("Moduleid", id);

    setId(id);
    // if (id === "1") {
    //   let params = {
    //     token: localStorage.getItem("token"),
    //   };

    //   SwaranandhraService.userLogout(params).then(() => {
    //     console.log("User logged out successfully.");
    //     localStorage.clear();

    //     // Open the new tab
    //     const newTab = window.open("https://planningportal.test.nidhi.apcfss.in/Menubar", "_blank");

    //     if (newTab) {
    //       console.log("New tab opened.");

    //       // Handshake listener to detect readiness
    //       const handshakeListener = (event) => {
    //         console.log("Received handshake:", event);

    //         if (event.origin === "https://planningportal.test.nidhi.apcfss.in" && event.data === "READY") {
    //           console.log("Handshake confirmed. Sending credentials...");

    //           // Send credentials
    //           newTab.postMessage(
    //             {
    //               username: username,
    //               password: Passwd,
    //               origin: "https://swarnandhra.test.nidhi.apcfss.in",
    //             },
    //             "https://planningportal.test.nidhi.apcfss.in"
    //           );

    //           // Redirect to blank before closing
    //           // window.location.href = "about:blank";

    //           // Give a slight delay to ensure redirection happens
    //           setTimeout(() => {
    //             window.close();
    //           }, 100);

    //           // Clean up listener
    //           window.removeEventListener("message", handshakeListener);
    //         }
    //       };

    //       window.addEventListener("message", handshakeListener);
    //     } else {
    //       console.error("Failed to open new tab. Please allow pop-ups.");
    //     }
    //   });
    // }

    if (id === "1") {
      let params = {
        token: localStorage.getItem("token"),
      };

      SwaranandhraService.userLogout(params).then(() => {
        console.log("User logged out successfully.");
        localStorage.clear();

        // Open the new tab with the desired URL
        // const newTab = window.open("https://planningportal.test.nidhi.apcfss.in/Menubar", "_blank");

        // if (newTab) {
        //   console.log("New tab opened.");

        //   // Open the current window in a new context, making it closable
        //   const currentTab = window.open("about:blank", "_self");

        //   // Handshake listener to detect readiness
        //   const handshakeListener = (event) => {
        //     console.log("Received handshake:", event);

        //     if (
        //       event.origin === "https://planningportal.test.nidhi.apcfss.in" &&
        //       event.data === "READY"
        //     ) {
        //       console.log("Handshake confirmed. Sending credentials...");

        //       // Send credentials
        //       newTab.postMessage(
        //         {
        //           username: username,
        //           password: Passwd,
        //           origin: "https://swarnandhra.test.nidhi.apcfss.in",
        //         },
        //         "https://planningportal.test.nidhi.apcfss.in"
        //       );

        //       // Close the current tab after a short delay
        //       setTimeout(() => {
        //         currentTab.close();
        //       }, 100);

        //       // Clean up the listener
        //       window.removeEventListener("message", handshakeListener);
        //     }
        //   };

        //   window.addEventListener("message", handshakeListener);
        // } else {
        //   console.error("Failed to open new tab. Please allow pop-ups.");
        // }

        // const newTab = window.open("https://planningportal.test.nidhi.apcfss.in/Menubar", "_blank");

        // if (newTab) {
        //   console.log("New tab opened.");

        //   // Use a timer to ensure the tab fully loads before sending the message
        //   const sendCredentials = () => {
        //     if (!newTab.closed) {
        //       console.log("Sending credentials...");

        //       newTab.postMessage(
        //         {
        //           username: username,   // Replace with the actual username variable
        //           password: Passwd,     // Replace with the actual password variable
        //         },
        //         "https://planningportal.test.nidhi.apcfss.in"
        //       );

        //       console.log("Credentials sent.");
        //     } else {
        //       console.warn("New tab closed before sending credentials.");
        //     }
        //   };

        //   // Wait for the tab to load fully before sending the message
        //   newTab.onload = () => {
        //     console.log("New tab loaded, sending credentials...");
        //     sendCredentials();
        //   };

        //   // Fallback in case the onload event doesn't fire
        //   setTimeout(() => {
        //     console.log("Timeout reached, sending credentials...");
        //     sendCredentials();
        //   }, 3000);  // Send after 3 seconds if the tab doesn't trigger `onload`

        // } else {
        //   console.error("Failed to open new tab. Please allow pop-ups.");
        // }

        // Open the new tab first
        const newTab = window.open(
          "https://planningportal.test.nidhi.apcfss.in/Menubar",
          "_blank",
          "noopener,noreferrer",
        );

        if (newTab) {
          console.log("New tab opened.");

          // Close the current tab (first tab)
          setTimeout(() => {
            window.close();
            console.log("First tab closed.");
          }, 500); // Small delay to ensure the new tab opens properly

          const sendCredentials = () => {
            if (!newTab.closed) {
              console.log("Sending credentials...");

              newTab.postMessage(
                {
                  username: username,
                  // password: portal_pwd,
                },
                "https://planningportal.test.nidhi.apcfss.in",
              );

              console.log("Credentials sent.");
              setTimeout(() => {
                window.open("about:blank", "_self").close();
              }, 100);
            } else {
              console.warn("New tab closed before sending credentials.");
            }
          };

          // Ensure the message is sent once the new tab fully loads
          newTab.onload = () => {
            console.log("New tab loaded, sending credentials...");
            sendCredentials();
          };

          // Fallback in case the `onload` event doesn't fire
          setTimeout(() => {
            console.log("Timeout reached, sending credentials...");
            sendCredentials();
          }, 3000);
        } else {
          console.error("Failed to open new tab. Please allow pop-ups.");
        }
      });
    } else {
      let params = {
        userId: localStorage.getItem("username"),
        roleId: localStorage.getItem("role"),
        subModuleId: id,
        token: localStorage.getItem("token"),
      };

      DesService.getModuleData(params).then((res) => {
        if (id === "3") {
          getNotifications();

          if (window.notificationInterval) {
            clearInterval(window.notificationInterval);
          }

          // window.notificationInterval = setInterval(() => {
          //   getNotifications();
          //  }, 15 * 60 * 1000);
          // }, 10000);
        } else {
          localStorage.setItem("showNotificationBanner", "false");
          if (window.notificationInterval) {
            clearInterval(window.notificationInterval);
          }
        }
        //   if (id === "3") {
        //   if (res.data?.NotificationList?.length > 0) {
        //     localStorage.setItem("showNotificationBanner", "true");

        //     const marqueeList = res.data?.NotificationList?.map(item => ({
        //       subject: item.subject,
        //       subjectDesc: item.subject_desc,
        //       dept_notification_files: item.dept_notification_files
        //     }));
        //     setMarqueeMessages(marqueeList);
        // localStorage.setItem("marqueeList", JSON.stringify(marqueeList));
        // setMarqueeMessages(marqueeList);
        //   } else {
        //     setMarqueeMessages([]);
        //     localStorage.setItem("showNotificationBanner", "false");
        //   }
        // } else {
        //   localStorage.setItem("showNotificationBanner", "false");
        // }
        localStorage.setItem("subId", id);
        localStorage.setItem("Subdata", JSON.stringify(res?.data?.SDESC));

        localStorage.setItem(
          "pendingMsgForGMDP",
          res?.data?.pendingMsgForGMDPContributions,
        );
        localStorage.setItem("dashboardStatusForTA_GMDP", JSON.stringify(res?.data?.dashboardStatusForTA_GMDP),); localStorage.setItem("approved", res?.data?.dashboardStatusForTA_GMDP?.approved_t_a,);
        localStorage.setItem("pending_at_cpo", res?.data?.dashboardStatusForTA_GMDP?.pending_at_cpo_t_a,);
        localStorage.setItem("mandal_total_count", res?.data?.dashboardStatusForTA_GMDP?.mandal_total_count,); localStorage.setItem("pending_at_aso", res?.data?.dashboardStatusForTA_GMDP?.pending_at_aso_t_a,);
        localStorage.setItem("pending_at_ad", res?.data?.dashboardStatusForTA_GMDP?.pending_at_ad_t_a,); localStorage.setItem("to_bestart_aso_t_a", res?.data?.dashboardStatusForTA_GMDP?.to_bestart_aso_t_a,);
        localStorage.setItem("dashboardStatusForTA_GMDP", JSON.stringify(res?.data?.dashboardStatusAtASO),); localStorage.setItem("aso_approved", res?.data?.dashboardStatusAtASO?.approved_t_a,);
        localStorage.setItem("aso_pending_at_cpo", res?.data?.dashboardStatusAtASO?.pending_at_cpo_t_a,); localStorage.setItem("aso_mandal_total_count", res?.data?.dashboardStatusAtASO?.mandal_total_count,);
        localStorage.setItem("aso_pending_at_aso", res?.data?.dashboardStatusAtASO?.pending_at_aso_t_a,); localStorage.setItem("aso_pending_at_ad", res?.data?.dashboardStatusAtASO?.pending_at_ad_t_a,);
        localStorage.setItem("aso_to_bestart_aso_t_a", res?.data?.dashboardStatusAtASO?.to_bestart_aso_t_a,);

        // kpi dashboard counts
        //mandal officer
        if (res?.data?.SDESC?.roleid == "31") {
          console.log("roleid", res?.data?.SDESC?.roleid);
          localStorage.setItem(
            "pending_at_mandal_officer_t_a",
            res?.data?.mandalLevelDashboardStatusAtASOLevel
              ?.pending_at_mandal_officer_t_a,
          );
          localStorage.setItem(
            "pending_at_district_officer_t_a",
            res?.data?.mandalLevelDashboardStatusAtASOLevel
              ?.pending_at_district_officer_t_a,
          );
          localStorage.setItem(
            "to_bestart_mandal_officer_t_a",
            res?.data?.mandalLevelDashboardStatusAtASOLevel
              ?.to_bestart_mandal_officer_t_a,
          );
          localStorage.setItem(
            "pending_at_hod_officer_t_a",
            res?.data?.mandalLevelDashboardStatusAtASOLevel
              ?.pending_at_hod_officer_t_a,
          );
          localStorage.setItem(
            "approved_t_a",
            res?.data?.mandalLevelDashboardStatusAtASOLevel?.approved_t_a,
          );
        }
        //DISTRICT oFFICER
        if (res?.data?.SDESC?.roleid == "32") {
          console.log("roleid", res?.data?.SDESC?.roleid);
          localStorage.setItem(
            "mandal_total_count",
            res?.data?.mandalLevelDashboardStatusAtCpoLevel?.mandal_total_count,
          );
          localStorage.setItem(
            "pending_at_mandal_officer_t_a",
            res?.data?.mandalLevelDashboardStatusAtCpoLevel
              ?.pending_at_mandal_officer_t_a,
          );
          localStorage.setItem(
            "pending_at_district_officer_t_a",
            res?.data?.mandalLevelDashboardStatusAtCpoLevel
              ?.pending_at_district_officer_t_a,
          );
          localStorage.setItem(
            "to_bestart_mandal_officer_t_a",
            res?.data?.mandalLevelDashboardStatusAtCpoLevel
              ?.to_bestart_mandal_officer_t_a,
          );
          localStorage.setItem(
            "pending_at_hod_officer_t_a",
            res?.data?.mandalLevelDashboardStatusAtCpoLevel
              ?.pending_at_hod_officer_t_a,
          );
          localStorage.setItem(
            "approved_t_a",
            res?.data?.mandalLevelDashboardStatusAtCpoLevel?.approved_t_a,
          );

          localStorage.setItem(
            "dist_pending_at_district_officer_t_a",
            res?.data?.districtLevelDashboardStatusAtCpoLevel
              ?.pending_at_district_officer_t_a,
          );
          localStorage.setItem(
            "dist_to_bestart_district_officer_t_a",
            res?.data?.districtLevelDashboardStatusAtCpoLevel
              ?.to_bestart_district_officer_t_a,
          );
          localStorage.setItem(
            "dist_pending_at_hod_officer_t_a",
            res?.data?.districtLevelDashboardStatusAtCpoLevel
              ?.pending_at_hod_officer_t_a,
          );
          localStorage.setItem(
            "dist_approved_t_a",
            res?.data?.districtLevelDashboardStatusAtCpoLevel?.approved_t_a,
          );
        }
        // Hod officer
        if (res?.data?.SDESC?.roleid == "60") {
          console.log("roleid", res?.data?.SDESC?.roleid);
          localStorage.setItem(
            "mandal_total_districts",
            res?.data?.mandalLevelDashboardStatusAtHodLevel?.total_districts,
          );
          localStorage.setItem(
            "mandal_not_started_districts",
            res?.data?.mandalLevelDashboardStatusAtHodLevel
              ?.not_started_districts,
          );
          localStorage.setItem(
            "mandal_started_districts",
            res?.data?.mandalLevelDashboardStatusAtHodLevel?.started_districts,
          );

          localStorage.setItem(
            "dist_total_districts",
            res?.data?.districtLevelDashboardStatusAtHodLevel?.total_districts,
          );
          localStorage.setItem(
            "dist_not_started_districts",
            res?.data?.districtLevelDashboardStatusAtHodLevel
              ?.not_started_districts,
          );
          localStorage.setItem(
            "dist_started_districts",
            res?.data?.districtLevelDashboardStatusAtHodLevel
              ?.started_districts,
          );

          localStorage.setItem(
            "hod_to_bestart_hod_officer_t_a",
            res?.data?.hodLevelDashboardStatusAtHodLevel
              ?.to_bestart_hod_officer_t_a,
          );
          localStorage.setItem(
            "hod_pending_at_hod_t_a",
            res?.data?.hodLevelDashboardStatusAtHodLevel?.pending_at_hod_t_a,
          );
          localStorage.setItem(
            "hod_approved_t_a",
            res?.data?.hodLevelDashboardStatusAtHodLevel?.approved_t_a,
          );
        }
        setSubmoduleServices(res?.data?.SDESC);
        setModEnb(false);
        if (
          id === "3" &&
          (!["60", "61", "5"].includes(roleid) ||
            parseInt(nodelOfficerMapService) != 0 ||
            userType != "CORP")
        ) {
          if (["67", "68", "69", "64", "65"].includes(roleid)) {
            navigate("/scoresdashboard");
          } else {
            navigate("/KPIDashboard");
          }
        } else if (id !== "5") {
          navigate("/mapnodalOfficers");
        }

        if (id === "2") {
          navigate("/Dashboard");
        }
      });
    }
  };
  const Switchenb = () => {
    setMarqueeMessages([]);
    localStorage.setItem("showNotificationBanner", "false");
    localStorage.removeItem("marqueeList");
    localStorage.setItem("Moduleid", null);

    let params = {
      userId: localStorage.getItem("username"),
      roleId: localStorage.getItem("role"),
      subModuleId: null,
      token: localStorage.getItem("token"),
    };
    DesService.getModuleData(params).then((res) => {
      localStorage.setItem("Subdata", JSON.stringify(res?.data?.SDESC));
      setSubmoduleServices(res?.data?.SDESC);
    });
    localStorage.removeItem("subId");
    setModEnb(true);
    console.log("Switchenb triggered");
    if (location.pathname === "/Menubar") {
      console.log("Already on Menubar, skipping navigation");
      return;
    }

    navigate("/Menubar");
  };

  //   useEffect(() => {
  //   console.log("Path changed to:", location.pathname);
  //   setModEnb(location.pathname === "/Menubar");
  // }, [location.pathname]);

  useEffect(() => {
    setSubId(SubId);
  }, [SubId]);

  const icons = [
    TbRosetteNumber1,
    TbRosetteNumber2,
    TbRosetteNumber3,
    TbRosetteNumber4,
  ];
  const colors = ["#ffb64d", "#59e0c5", "#4dff88", "#ff4d4d", "#a64dff"];

  const [notificationcount, setnotificationcount] = useState();
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([
    "KpiIndicatorentry Service available",
    "Your data entry was approved",
    "KpiIndicatorReport Added",
  ]);

  const handleBellClick = () => {
    setShowNotifications(!showNotifications);
  };
  const cardRef = useRef(null);
  const handlekey = (e) => {
    if (e.key === "Enter" || e.key === "Escape") {
      setShowNotifications(false);
    }
  };

  const disableBackButton = () => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function (event) {
      window.history.go(1);
    };
  };
  const handleKeyDown = (e) => {
    // Prevent closing the modal on Enter or Escape keys
    if (e.key === "Enter" || e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  useEffect(() => {
    setnotificationcount(5);
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => {
        const newCountdown = prevCountdown - 1;
        localStorage.setItem("countdown", newCountdown);
        return newCountdown;
      });
    }, 1000);
    if (countdown === 300) {
      setAddModal(true);
    }
    if (countdown === 0) {
      clearInterval(interval);
      handleSessionTimeout();
    }

    return () => clearInterval(interval);
  }, [countdown]);

  const handleSessionTimeout = () => {
    disableBackButton();
    setAddModal(false);
    showAlertMessage("Session expired. Please log in again.", "error", () => {
      let params = {
        token: localStorage.getItem("token"),
      };

      SwaranandhraService.userLogout(params).then(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("serviceList");
        localStorage.clear();
        navigate("/SwarnandhraLogin");
        localStorage.removeItem("Menu");
      });
    });

    // Swal.fire({
    //   text: "Session expired. Please log in again.",
    //   icon: "warning",
    // }).then(() => {
    //   let params = {
    //     token: localStorage.getItem("token"),
    //   };

    //   SwaranandhraService.userLogout(params).then(() => {
    //     localStorage.removeItem("token");
    //     localStorage.removeItem("serviceList");
    //     localStorage.clear();

    //     navigate("/SwarnandhraLogin");
    //     localStorage.removeItem("Menu");
    //   });
    // });
  };

  const [addModal, setAddModal] = useState();
  const handleClose = () => {
    setAddModal(false);
  };

  const handleSessionTimeClick = () => {
    setAddModal(true);
  };

  const handleConfirmSessionExtension = () => {
    let params = {
      username: username,
    };

    SwaranandhraService.Relogin(params).then((res) => {
      let newToken = res.data.SDESC;
      localStorage.setItem("token", newToken);
      setCountdown(2400);
      setAddModal(false);
    });
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
  };

  const [enteryFormServices, setEntryFormServices] = useState([]);

  const fetchData = async () => {
    try {
      let menu = JSON.parse(localStorage.getItem("Menu"));
      setEntryFormServices(menu);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const locale = "en";
  const day = new Date().toLocaleDateString(locale, { weekday: "long" });
  const date = `${day}, ${new Date().getDate()} ${new Date().toLocaleDateString(
    locale,
    { month: "long" },
  )} ${new Date().toLocaleDateString(locale, { year: "numeric" })}\n\n`;

  // const renderSubMenu = (subMenu) => {
  //   return (
  //     <NavDropdown >
  //       {subMenu.subchilds.map((subItem, subIndex) => (
  //         <NavDropdown.Item key={subIndex} href={subItem.targeturl_sc}>
  //           {subItem.menuitemname_sc}
  //         </NavDropdown.Item>
  //       ))}
  //       <NavDropdown.Divider />
  //       </NavDropdown>

  //   );
  // };

  const [openSubMenu, setOpenSubMenu] = useState(null);
  // const [subMenuPos, setSubMenuPos] = useState({ top: 0, left: 0 });
  const [subMenuPos, setSubMenuPos] = useState({
    top: 0,
    left: 0,
    width: 230,
    mode: "side",
  });
  // const handleToggleSubMenu = (index) => {
  //   setOpenSubMenu(openSubMenu === index ? null : index);
  // };
  const submenuRef = useRef(null);

  const handleToggleSubMenu = (childIndex, e) => {
    if (childIndex === null) {
      setOpenSubMenu(null);
      return;
    }
    if (!e || !e.currentTarget) return;

    const rect = e.currentTarget.getBoundingClientRect();
    const dropdownMenu = e.currentTarget.closest(".dropdown-menu");
    if (!dropdownMenu) return;

    const dropdownRect = dropdownMenu.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // ── Measure actual text width of subchilds ──
    const subchilds =
      e.currentTarget
        .closest("[data-subchild-count]")
        ?.querySelectorAll?.("[data-submenu-label]") || [];

    // Use canvas to measure text width dynamically
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx.font = "14px sans-serif"; // match your app font

    let maxTextWidth = 160; // minimum width
    if (subchilds.length > 0) {
      subchilds.forEach((el) => {
        const w = ctx.measureText(el.textContent).width;
        if (w > maxTextWidth) maxTextWidth = w;
      });
    } else {
      // fallback: read from dataset if labels passed as JSON
      const labelsRaw = e.currentTarget.closest("[data-submenu-labels]")
        ?.dataset?.submenuLabels;
      if (labelsRaw) {
        try {
          JSON.parse(labelsRaw).forEach((label) => {
            const w = ctx.measureText(label).width;
            if (w > maxTextWidth) maxTextWidth = w;
          });
        } catch { }
      }
    }

    const submenuWidth = Math.ceil(maxTextWidth) + 40; // 40px padding (icon + sides)

    // ── Horizontal: right of dropdown, fallback to left ──
    const spaceOnRight = viewportWidth - dropdownRect.right;
    const spaceOnLeft = dropdownRect.left;
    let leftPos;

    if (spaceOnRight >= submenuWidth) {
      leftPos = dropdownRect.right + 2;
    } else if (spaceOnLeft >= submenuWidth) {
      leftPos = dropdownRect.left - submenuWidth - 2;
    } else {
      // not enough space on either side — pick the larger side and clip gracefully
      if (spaceOnRight >= spaceOnLeft) {
        leftPos = dropdownRect.right + 2;
      } else {
        leftPos = dropdownRect.left - submenuWidth - 2;
      }
    }

    // ── Vertical: align with hovered item, shift up if overflow ──
    const submenuItemHeight = 36;
    const subchildCount =
      e.currentTarget.closest("[data-subchild-count]")?.dataset
        ?.subchildCount || 5;
    const estimatedHeight = submenuItemHeight * parseInt(subchildCount) + 20;

    let topPos = rect.top;
    if (topPos + estimatedHeight > viewportHeight) {
      topPos = Math.max(10, viewportHeight - estimatedHeight - 10);
    }
    topPos = Math.max(50, topPos);

    setSubMenuPos({
      top: topPos,
      left: leftPos,
      width: submenuWidth,
      mode: "side",
    });

    setOpenSubMenu(childIndex);
  };
  //   const handleToggleSubMenu = (childIndex, e) => {
  //   if (childIndex === null) {
  //     setOpenSubMenu(null);
  //     return;
  //   }
  //   const rect = e.currentTarget.getBoundingClientRect();

  //   // Get the parent dropdown menu's right edge
  //   const dropdownMenu = e.currentTarget.closest('.dropdown-menu');
  //   const dropdownRect = dropdownMenu.getBoundingClientRect();

  //   setSubMenuPos({
  //     top: rect.top,          // align with the hovered item vertically
  //     left: dropdownRect.right, // start from the dropdown's right edge, not the item's
  //   });
  //   setOpenSubMenu(childIndex);
  // };

  const dropdownScrollRef = useRef(null);
  const renderSubMenu = (childItem, index) => {
    return (
      <>
        {/* Clickable main child to toggle subchilds */}
        <NavDropdown.ItemText
          style={{ cursor: "pointer" }}
          onClick={() => handleToggleSubMenu(index)}
        >
          <>
            {childItem.menuitemname_c}
            {childItem.menuitemname_c === "GSDP Entry" && (
              <>
                <p>hello</p>
                <img
                  src="../images/new.gif"
                  width="10px"
                  alt="new"
                  style={{ marginLeft: "5px" }}
                />
              </>
            )}
          </>
        </NavDropdown.ItemText>

        {/* Show subchilds only if open */}
        {openSubMenu === index &&
          childItem.subchilds.map((subItem, subIndex) => (
            <NavDropdown.Item
              key={subIndex}
              href={subItem.targeturl_sc}
              onClick={() => {
                localStorage.setItem(
                  "selectedMenuEntry",
                  subItem.menuitemname_sc,
                );
              }}
            >
              {subItem.menuitemname_sc}
            </NavDropdown.Item>
          ))}

        <NavDropdown.Divider />
      </>
    );
  };

  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose1 = () => setShowModal(false);

  const handleConfirm = () => {
    const params = {
      token: localStorage.getItem("token"),
    };

    SwaranandhraService.userLogout(params).then(() => {
      localStorage.removeItem("token");
      localStorage.removeItem("serviceList");
      localStorage.removeItem("Menu");
      localStorage.clear();

      // Show success alert and navigate to login
      showAlertMessage("You have Successfully Logged Out", "success", () => {
        navigate("/SwarnandhraLogin");
      });

      handleClose1();
    });
  };

  const handleCancel = () => {
    handleClose1();
  };

  function handleLogOut() {
    disableBackButton();

    handleShow();
  }

  const navigate = useNavigate();
  const individualDashboardfun = () => {
    setMarqueeMessages([]);
    localStorage.setItem("showNotificationBanner", "false");
    localStorage.removeItem("marqueeList");
    localStorage.setItem("Moduleid", null);
    SwaranandhraService.individualDashboard().then((res) => {
      if (res.data) {
        localStorage.setItem("dashboardStatusForTA_GMDP", JSON.stringify(res?.data?.dashboardStatusForTA_GMDP),); localStorage.setItem("approved", res?.data?.dashboardStatusForTA_GMDP?.approved_t_a,); localStorage.setItem("pending_at_cpo", res?.data?.dashboardStatusForTA_GMDP?.pending_at_cpo_t_a,);
        localStorage.setItem("mandal_total_count", res?.data?.dashboardStatusForTA_GMDP?.mandal_total_count,); localStorage.setItem("pending_at_aso", res?.data?.dashboardStatusForTA_GMDP?.pending_at_aso_t_a,); localStorage.setItem("pending_at_ad", res?.data?.dashboardStatusForTA_GMDP?.pending_at_ad_t_a,);
        localStorage.setItem("to_bestart_aso_t_a", res?.data?.dashboardStatusForTA_GMDP?.to_bestart_aso_t_a,);

        localStorage.setItem("dashboardStatusForTA_GMDP", JSON.stringify(res?.data?.dashboardStatusAtASO),); localStorage.setItem("aso_approved", res?.data?.dashboardStatusAtASO?.approved_t_a,);
        localStorage.setItem("aso_pending_at_cpo", res?.data?.dashboardStatusAtASO?.pending_at_cpo_t_a,); localStorage.setItem("aso_mandal_total_count", res?.data?.dashboardStatusAtASO?.mandal_total_count,);
        localStorage.setItem("aso_pending_at_aso", res?.data?.dashboardStatusAtASO?.pending_at_aso_t_a,); localStorage.setItem("aso_pending_at_ad", res?.data?.dashboardStatusAtASO?.pending_at_ad_t_a,);
        localStorage.setItem("aso_to_bestart_aso_t_a", res?.data?.dashboardStatusAtASO?.to_bestart_aso_t_a,);
      }
      navigate("/Menubar");
    });
  };
  const [history, setHistory] = useState([]);
  const [showHistory, setShowHistory] = useState(false);

  const historyRef = useRef(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  // Load history from localStorage when the component mounts
  useEffect(() => {
    const storedHistory = JSON.parse(localStorage.getItem("navHistory")) || [];
    setHistory(storedHistory);
  }, []);

  useEffect(() => {
    const currentPath = location.pathname.replace(/^\/+/, "");
    let menuEntry = null;
    let menuPath = null;
    enteryFormServices.forEach((menuItem) => {
      menuItem.childs?.forEach((childItem) => {
        if (childItem.targeturl_c === currentPath) {
          menuEntry = childItem.menuitemname_c;
          menuPath = childItem.targeturl_c;
        }
        childItem.subchilds?.forEach((subItem) => {
          if (subItem.targeturl_sc === currentPath) {
            menuEntry = `${childItem.menuitemname_c} - ${subItem.menuitemname_sc}`;
            menuPath = subItem.targeturl_sc;
          }
        });
      });
    });

    if (menuEntry && menuPath) {
      setHistory((prev) => {
        const newHistory = [{ name: menuEntry, path: menuPath }, ...prev];
        localStorage.setItem("navHistory", JSON.stringify(newHistory));
        return newHistory;
      });
    }
  }, [location, enteryFormServices]);

  const toggleHistory = () => {
    setShowHistory(!showHistory);
  };

  const handleNavigation = (historyItem) => {
    navigate(`/${historyItem.path}`); // Use stored path
    setShowHistory(false);
  };

  const notificationRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (historyRef.current && !historyRef.current.contains(event.target)) {
        setShowHistory(false);
      }
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };

    const handleKeyPress = (event) => {
      if (event.key === "Escape" || event.key === "Enter") {
        setShowHistory(false);
        setShowNotifications(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyPress);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    <>
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          backgroundColor: "#fff",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* <section id="">
        <Container fluid>
          <Row className=" ">
            <div className="d-block d-sm-flex justify-content-between logo-all px-3">
              <div className="d-flex">
                <div>
                  <img src="../images/aplogo.webp" width="70px" alt="APlogo" className="img-fluid" />
                </div>
                <div className="header-logo">
                  <h1> SWARNA <span>ANDHRA @2047</span> </h1>
                  <h5>A.P. PLANNING DEPARTMENT</h5>
                </div>
              </div>
              <div className="log-details">
                <Nav>
                  <div className="d-flex align-items-center">
                    <b> Welcome: </b>{" "}
                    <p className="login-name">
                      {localStorage.getItem("dispName")}{" "}
                      {localStorage.getItem("username")}
                      <br />
                      {roleid === "31" || roleid === "3" ? "Mandal Officer" : roleid === "32" || roleid === "2" ? "District Officer" : roleid === "60" || roleid === "5" ? "Hod Officer" : ""}
                      <br />
                      {roleid === "31" || roleid === "3" ? localStorage.getItem("mandalname") : roleid === "32" || roleid === "2" ? localStorage.getItem("districtname") : roleid === "60" || roleid === "5" ? localStorage.getItem("hod_name") : ""}
                    </p>

                    <img data-tip data-for="userTooltip" src="../images/welcome-user.webp" style={{ cursor: "pointer" }} alt="user" />
                    <Tooltip

                      id="userTooltip"
                      place="bottom"
                      effect="solid"
                      backgroundColor="linear-gradient(135deg, #FFFACD, #FBB040)"
                      className="custom-tooltip"
                      offset={{ top: -8 }}
                    >
                      <div className="tooltip-content p-2 rounded-3">
                        <div>
                          <div className="d-flex">
                            <p
                              style={{
                                fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                                fontSize: "1rem",
                              }}
                              className="fw-bold"
                            >
                              Last Logging Time
                            </p>{" "}
                            <LuClock style={{ fontSize: "21px" }} className="mb-1 mx-2" />
                          </div>
                          <p
                            style={{
                              fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                              fontSize: "1rem",
                            }}
                          >
                            {localStorage.getItem("lastlogintime")}
                          </p>
                        </div>
                        <div className="d-flex flex-column ">
                          <p
                            style={{
                              fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                              fontSize: "1rem",
                            }}
                            className="fw-bold"
                          >
                            Current Time
                          </p>
                          <p
                            style={{
                              fontFamily: "Segoe UI, Tahoma, Geneva, Verdana, sans-serif",
                              fontSize: "1rem",
                            }}
                          >
                            {date}
                            <GiAlarmClock
                              style={{ fontSize: "20px", color: "white" }}
                              className="mx-1 mb-1 fw-bold"
                            />
                            <Clock format={"HH:mm:ss A"} ticking={true} timezone={"Asia/Kolkata"} />
                          </p>
                        </div>
                      </div>
                    </Tooltip
>
                  </div>


                </Nav>
              </div>
            </div>
          </Row>
        </Container>
      </section> */}

        <section id="">
          <Container fluid>
            <Row className=" ">
              <div className="d-block d-sm-flex justify-content-between logo-all px-3 pb-0">
                {/* <div className="d-flex">
                <div>
                  <img src="../images/aplogo.webp" width="70px" alt="APlogo" className="img-fluid" />
                </div>
                <div className="header-logo">
                  <h1>
                    SWARNA <span>ANDHRA @2047</span>
                  </h1>
                  <h5>A.P. PLANNING DEPARTMENT</h5>
                </div>
              </div> */}
                <div>
                  <img
                    src="images/swarna-logo.svg"
                    className="img-fluid w-75"
                  />
                </div>
                <div className="log-details mt-0">
                  <Nav>
                    <div className="d-flex align-items-center gap-2">
                      {/* <div onClick={handleSessionTimeClick} onKeyDown={(e) => {if (e.key === "Enter" || e.key === " ") {
              handleSessionTimeClick(); }}}
          role="button" tabIndex={0}  className="session-dropdown rounded-pill" style={{ cursor: "pointer", fontFamily: "sans-serif", fontSize: "medium" }} >
          <LuTimer  fontSize={14} />  Session: {formatTime(countdown)}
        </div> */}
                      {/* <div>|</div> */}
                      {/* <div className="header-dropdown-setting d-flx algn-items-center">
                        <b className="me-1">WELCOME:</b>
                        <span>
                          <span className="text-danger">{localStorage.getItem("dispName")}</span>,&nbsp;&nbsp;
                          <span className="d-block">
                            {localStorage.getItem("username")}&nbsp;&nbsp;
                            {roleid === "31" || roleid === "3" ? ",Mandal Officer" : roleid === "32" || roleid === "2" ? ",District Officer" : roleid === "60" || roleid === "5" ? ",Hod Officer" : ""}&nbsp;&nbsp;
                            {roleid === "31" || roleid === "3" ? localStorage.getItem("mandalname") : roleid === "32" || roleid === "2" ? localStorage.getItem("districtname") : roleid === "60" || roleid === "5" ? localStorage.getItem("hod_name") : ""}
                          </span>
                        </span>
                      </div>

                      <NavDropdown style={{ fontFamily: "sans-serif" }} id="basic-nav-dropdown" className="custom-dropdown">
                        <NavDropdown.Item className="dropdown-item d-flex align-items-center gap-2">
                          <span style={{ fontSize: "17px" }}>🕒</span>
                          <div>
                            <span className="fw-bold">Last Login Time:</span> <br /> <span>{localStorage.getItem("lastlogintime")}</span>
                          </div>
                        </NavDropdown.Item>
                        <NavDropdown.Item className="dropdown-item d-flex align-items-center gap-2">
                          <FcAlarmClock size={20} />
                          <div>
                            <span className="fw-bold">Current Time:</span> <br /> {date} <Clock format="HH:mm:ss A" ticking timezone="Asia/Kolkata" />
                          </div>
                        </NavDropdown.Item>
                        {/* <NavDropdown.Divider /> */}
                      {/* <NavDropdown.Item className="dropdown-item text-dange d-flex align-items-center gap-2" >

                        </NavDropdown.Item>
                      </NavDropdown> */}
                      <NavDropdown
                        title={
                          <div
                            className="header-dropdown-setting"
                            style={{ cursor: "pointer" }}
                          >
                            <b className="me-1">WELCOME:</b>
                            <span>
                              <span className="text-danger">
                                {localStorage.getItem("dispName") || "User"}
                              </span>
                              ,&nbsp;&nbsp;
                              <span className="d-block">
                                {localStorage.getItem("username") || "Username"}
                                &nbsp;&nbsp;
                                {roleid === "31" || roleid === "3"
                                  ? ", Mandal Officer"
                                  : roleid === "32" || roleid === "2"
                                    ? ", District Officer"
                                    : roleid === "60" || roleid === "5"
                                      ? ", Hod Officer"
                                      : ""}
                                &nbsp;&nbsp;
                                {roleid === "31" || roleid === "3"
                                  ? localStorage.getItem("mandalname")
                                  : roleid === "32" || roleid === "2"
                                    ? localStorage.getItem("districtname")
                                    : roleid === "60" || roleid === "5"
                                      ? localStorage.getItem("hod_name")
                                      : ""}
                              </span>
                            </span>
                          </div>
                        }
                        id="welcome-dropdown"
                        className="custom-dropdown py-0"
                        drop="down"
                        align="end"
                      >
                        <NavDropdown.Item className="d-flex align-items-center gap-2">
                          {" "}
                          <span style={{ fontSize: "17px" }}>🕒</span>{" "}
                          <div>
                            {" "}
                            <span className="fw-bold">
                              Last Login Time:
                            </span>{" "}
                            <br />{" "}
                            <span>
                              {localStorage.getItem("lastlogintime") || "N/A"}
                            </span>{" "}
                          </div>{" "}
                        </NavDropdown.Item>
                        <NavDropdown.Item className="d-flex align-items-center gap-2">
                          <FcAlarmClock size={20} />
                          <div>
                            {" "}
                            <span className="fw-bold">Current Time:</span>{" "}
                            <br /> {date}{" "}
                            <Clock
                              format="HH:mm:ss A"
                              ticking
                              timezone="Asia/Kolkata"
                            />{" "}
                          </div>{" "}
                        </NavDropdown.Item>
                      </NavDropdown>

                      <div className="session-dropdown " onClick={handleSessionTimeClick} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { handleSessionTimeClick(); } }} role="button" tabIndex={0} style={{ cursor: "pointer", fontFamily: "sans-serif", fontSize: "medium", }} >
                        {/* <LuTimer  fontSize={14} /> */}
                        <span className="d-block fs-4 fw-bold  text-center time-format text-dark"> {formatTime(countdown)} </span> <p className="mb-0">Session Time</p>
                      </div>
                      <Nav.Link className="login pe-0">
                        <button
                          className="btn btn-sm signout-btn"
                          onClick={handleLogOut}
                        >
                          <span className="fw-bold text-white">Logout</span>{" "}
                          <FiPower className="ps-1 text-white fw-bold logout-icon" />
                        </button>
                      </Nav.Link>
                    </div>
                  </Nav>
                </div>
              </div>
              <div className=" justify-content-between logo-all2 px-3 pb-0">
                {/* <div className="d-flex">
                <div>
                  <img src="../images/aplogo.webp" width="70px" alt="APlogo" className="img-fluid" />
                </div>
                <div className="header-logo">
                  <h1>
                    SWARNA <span>ANDHRA @2047</span>
                  </h1>
                  <h5>A.P. PLANNING DEPARTMENT</h5>
                </div>
              </div> */}
                <div className="d-flex align-items-center justify-content-between nav-logo2">
                  <img
                    src="images/swarna-logo.svg"
                    className="img-fluid w-75"
                  />
                  <NavDropdown
                    title={
                      <div
                        className="header-dropdown-setting"
                        style={{ cursor: "pointer" }}
                      >
                        <b className="me-1">WELCOME:</b>
                        <span>
                          <span className="text-danger">
                            {localStorage.getItem("dispName") || "User"}
                          </span>
                          ,&nbsp;&nbsp;
                          <span className="d-block">
                            {localStorage.getItem("username") || "Username"}
                            &nbsp;&nbsp;
                            {roleid === "31" || roleid === "3"
                              ? ", Mandal Officer"
                              : roleid === "32" || roleid === "2"
                                ? ", District Officer"
                                : roleid === "60" || roleid === "5"
                                  ? ", Hod Officer"
                                  : ""}
                            &nbsp;&nbsp;
                            {roleid === "31" || roleid === "3"
                              ? localStorage.getItem("mandalname")
                              : roleid === "32" || roleid === "2"
                                ? localStorage.getItem("districtname")
                                : roleid === "60" || roleid === "5"
                                  ? localStorage.getItem("hod_name")
                                  : ""}
                          </span>
                        </span>
                      </div>
                    }
                    id="welcome-dropdown"
                    className="custom-dropdown py-0"
                    drop="down"
                    align="end"
                  >
                    <NavDropdown.Item className="d-flex align-items-center gap-2">
                      <span style={{ fontSize: "17px" }}>🕒</span>
                      <div>
                        <span className="fw-bold">Last Login Time:</span> <br />
                        <span>
                          {localStorage.getItem("lastlogintime") || "N/A"}
                        </span>
                      </div>
                    </NavDropdown.Item>
                    <NavDropdown.Item className="d-flex align-items-center gap-2">
                      <FcAlarmClock size={20} />
                      <div>
                        <span className="fw-bold">Current Time:</span> <br />
                        {date}{" "}
                        <Clock
                          format="HH:mm:ss A"
                          ticking
                          timezone="Asia/Kolkata"
                        />
                      </div>
                    </NavDropdown.Item>
                  </NavDropdown>
                </div>
                <div className="log-details mt-0">
                  <Nav>
                    <div className="d-flex align-items-center gap-2">
                      {/* <div onClick={handleSessionTimeClick} onKeyDown={(e) => {if (e.key === "Enter" || e.key === " ") {
              handleSessionTimeClick(); }}}
          role="button" tabIndex={0}  className="session-dropdown rounded-pill" style={{ cursor: "pointer", fontFamily: "sans-serif", fontSize: "medium" }} >
          <LuTimer  fontSize={14} />  Session: {formatTime(countdown)}
        </div> */}
                      {/* <div>|</div> */}
                      {/* <div className="header-dropdown-setting d-flx algn-items-center">
                        <b className="me-1">WELCOME:</b>
                        <span>
                          <span className="text-danger">{localStorage.getItem("dispName")}</span>,&nbsp;&nbsp;
                          <span className="d-block">
                            {localStorage.getItem("username")}&nbsp;&nbsp;
                            {roleid === "31" || roleid === "3" ? ",Mandal Officer" : roleid === "32" || roleid === "2" ? ",District Officer" : roleid === "60" || roleid === "5" ? ",Hod Officer" : ""}&nbsp;&nbsp;
                            {roleid === "31" || roleid === "3" ? localStorage.getItem("mandalname") : roleid === "32" || roleid === "2" ? localStorage.getItem("districtname") : roleid === "60" || roleid === "5" ? localStorage.getItem("hod_name") : ""}
                          </span>
                        </span>
                      </div>

                      <NavDropdown style={{ fontFamily: "sans-serif" }} id="basic-nav-dropdown" className="custom-dropdown">
                        <NavDropdown.Item className="dropdown-item d-flex align-items-center gap-2">
                          <span style={{ fontSize: "17px" }}>🕒</span>
                          <div>
                            <span className="fw-bold">Last Login Time:</span> <br /> <span>{localStorage.getItem("lastlogintime")}</span>
                          </div>
                        </NavDropdown.Item>
                        <NavDropdown.Item className="dropdown-item d-flex align-items-center gap-2">
                          <FcAlarmClock size={20} />
                          <div>
                            <span className="fw-bold">Current Time:</span> <br /> {date} <Clock format="HH:mm:ss A" ticking timezone="Asia/Kolkata" />
                          </div>
                        </NavDropdown.Item>
                        {/* <NavDropdown.Divider /> */}
                      {/* <NavDropdown.Item className="dropdown-item text-dange d-flex align-items-center gap-2" >

                        </NavDropdown.Item>
                      </NavDropdown> */}

                      <div
                        className="session-dropdown "
                        onClick={handleSessionTimeClick}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            handleSessionTimeClick();
                          }
                        }}
                        role="button"
                        tabIndex={0}
                        style={{
                          cursor: "pointer",
                          fontFamily: "sans-serif",
                          fontSize: "medium",
                        }}
                      >
                        {/* <LuTimer  fontSize={14} /> */}
                        <span className="d-block fs-4 fw-bold  text-center time-format text-dark">
                          {formatTime(countdown)}
                        </span>
                        <p className="mb-0">Session Time</p>
                      </div>
                      <Nav.Item className="nav-logout bg-danger text-center text-white bg-danger text-white">
                        <Nav.Link
                          onClick={handleLogOut}
                          className="d-flex align-items-center logout-btn justify-content-center py-2"
                        >
                          <span className="fw-bold text-white">Logout</span>{" "}
                          <FiPower
                            size={20}
                            className="ps-1 text-white fw-bold "
                          />
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                  </Nav>
                </div>
              </div>
            </Row>
          </Container>
        </section>

        <Navbar
          collapseOnSelect
          expand="lg"
          style={{ position: "relative" }}
          className="nav-infor"
        >
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            {ModEnb === true
              ? enteryFormServices
                ?.filter((menuItem) => menuItem.menuitemname !== "Logout")
                .map((menuItem, index) => (
                  <div key={index} className="me-2">
                    {menuItem.childs && roleid !== "8" ? (
                      <></>
                    ) : (
                      <Nav.Link
                        className="me-auto "
                        key={index}
                        href={
                          menuItem.menuitemname === "Home"
                            ? "/Menubar"
                            : menuItem.menuitemname === "Change Password"
                              ? "/ChangePassword"
                              : menuItem.targeturl
                        }
                        onClick={(e) => {
                          if (menuItem.menuitemname === "Home") {
                            e.preventDefault();
                            individualDashboardfun();
                          } else if (menuItem.menuitemname === "Logout") {
                            e.preventDefault();
                            handleLogOut();
                          } else {
                            navigate(menuItem.targeturl);
                          }
                        }}
                        style={{ padding: "0px" }}
                      >
                        {menuItem.menuitemname === "Home" && (
                          <BsHouseFill
                            className="mx-1 mb-1"
                            style={{ fontSize: "14px" }}
                          />
                        )}
                        {menuItem.menuitemname === "Change Password" && (
                          <AiFillLock
                            className="mx-1 mb-1"
                            style={{ fontSize: "14px" }}
                          />
                        )}
                        {menuItem.menuitemname === "Logout" && (
                          <AiOutlineLogout
                            className="mx-1 mb-1"
                            onClick={handleLogOut}
                            style={{ fontSize: "15px" }}
                          />
                        )}

                        {!["Services", "Reports", "MER"].includes(
                          menuItem.menuitemname,
                        ) && (
                            <span style={{ fontSize: "12px", padding: "0px" }}>
                              {menuItem.menuitemname}
                            </span>
                          )}
                      </Nav.Link>
                    )}
                  </div>
                ))
              : SubmoduleServices?.filter(
                (menuItem) => menuItem.menuitemname !== "Logout",
              ).map((menuItem, index) => (
                <div key={index} className="me-3">
                  {menuItem.childs ? (
                    <NavDropdown
                      className="scrollable-dropdown"
                      key={index}
                      //                     onToggle={(isOpen) => {
                      //   if (isOpen) {
                      //     setOpenSubMenu(null);
                      //     setTimeout(() => {
                      //       // targets the currently opened dropdown menu
                      //       const menus = document.querySelectorAll('.scrollable-dropdown .dropdown-menu');
                      //       menus.forEach(menu => menu.scrollTop = 0);
                      //     }, 0);
                      //   }
                      // }}
                      title={
                        <>
                          {menuItem.menuitemname === "Data Entry" && (<AiOutlineForm className="mx-1 mb-1" style={{ fontSize: "15px" }} />)}
                          {menuItem.menuitemname === "Reports" && (<BsFillBarChartFill className="mx-1 mb-1" style={{ fontSize: "15px" }} />)}
                          {menuItem.menuitemname === "Services" && (<MdMiscellaneousServices className="mx-1 mb-1" style={{ fontSize: "15px" }} />)}
                          {menuItem.menuitemname === "Security" && (<MdOutlineSecurity className="mx-1 mb-1" style={{ fontSize: "15px" }} />)}
                          {menuItem.menuitemname === "Dashboard" && (<MdOutlineAutoGraph className="mx-1 mb-1" style={{ fontSize: "15px" }} />)}
                          {menuItem.menuitemname === "Analytical Reports" && (<TbDeviceAnalytics className="mx-1 mb-1" style={{ fontSize: "15px" }} />)}

                          <span style={{ fontSize: "12px" }}> {menuItem.menuitemname} </span>
                        </>
                      }
                      id={`nav-dropdown-${index}`}
                    >
                      {menuItem.childs.map((childItem, childIndex) => (
                        // <div key={childIndex} style={{ position: "relative" }}>

                        <div key={childIndex} className="submenu-container">
                          {childItem.subchilds.length > 0 ? (
                            <>
                              {/* <NavDropdown.Item style={{ cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }} onMouseEnter={(e) => handleToggleSubMenu(childIndex, e)} 
                           
                              onClick={() => { localStorage.setItem("selectedMenuEntry", childItem.menuitemname_c); }}
                              > */}
                              <NavDropdown.Item
                                data-subchild-count={
                                  childItem.subchilds.length
                                }
                                data-submenu-labels={JSON.stringify(
                                  childItem.subchilds.map(
                                    (s) => s.menuitemname_c,
                                  ),
                                )}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                                onMouseEnter={(e) =>
                                  handleToggleSubMenu(childIndex, e)
                                }
                                onClick={(e) => {
                                  handleToggleSubMenu(
                                    openSubMenu === childIndex
                                      ? null
                                      : childIndex,
                                    e,
                                  );
                                  localStorage.setItem(
                                    "selectedMenuEntry",
                                    childItem.menuitemname_c,
                                  );
                                }}
                              >
                                <span>
                                  {childItem.menuitemname_c}
                                  {childItem.menuitemname_c ===
                                    "GSDP Estimates Report" ||
                                    (childItem.menuitemname_c ===
                                      "GSDP Entry" && (
                                        <>
                                          <img
                                            src="../images/new1.gif"
                                            style={{
                                              marginLeft: "5px",
                                              width: "45px",
                                              height: "45px",
                                            }}
                                            alt="new"
                                          />
                                        </>
                                      ))}
                                </span>

                                <span
                                  style={{
                                    marginLeft: "10px",
                                    fontSize: "10px",
                                    transform:
                                      openSubMenu === childIndex
                                        ? "rotate(0deg)"
                                        : "rotate(90deg)",
                                    transition: "transform 0.2s ease",
                                  }}
                                >
                                  ▶
                                </span>
                              </NavDropdown.Item>
                              {openSubMenu === childIndex && (
                                <div
                                  ref={submenuRef}
                                  style={{
                                    position: "fixed",
                                    top: subMenuPos.top,
                                    left: subMenuPos.left,
                                    width: subMenuPos.width, // ← dynamic now
                                    minWidth: "max-content", // ← never clip text
                                    zIndex: 9999,
                                    backgroundColor: "#fff",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                                  }}
                                >
                                  {childItem.subchilds.map(
                                    (sub, subIndex) => (
                                      <NavDropdown.Item
                                        key={subIndex}
                                        href={sub.targeturl_sc}
                                        style={{ whiteSpace: "nowrap" }} // ← never wrap text
                                        onClick={() => {
                                          localStorage.setItem(
                                            "selectedMenuEntry",
                                            sub.menuitemname_sc,
                                          );
                                        }}
                                      >
                                        {sub.menuitemname_sc}
                                      </NavDropdown.Item>
                                    ),
                                  )}
                                </div>
                              )}
                            </>
                          ) : (
                            <NavDropdown.Item
                              key={childIndex}
                              href={childItem.targeturl_c}
                              onMouseEnter={() => handleToggleSubMenu(null)}
                              onClick={(e) => {
                                localStorage.setItem(
                                  "selectedMenuEntry",
                                  childItem.menuitemname_c,
                                );
                                //  if(catid !== "116"){
                                //     if (["sdgscoresdashboard","abstractreport","economicscoresdashboard","scoresdashboard"].includes(childItem.targeturl_c) ) {
                                //       navigate("/MaintanceImage");
                                //       e.preventDefault();
                                //     } else {
                                //       setShowDashboardImage(null);
                                //     }
                                //   }
                              }}
                            // onClick={() => { localStorage.setItem("selectedMenuEntry", childItem.menuitemname_c); }}>
                            >
                              <span>{childItem.menuitemname_c}</span>
                              {(childItem.menuitemname_c ===
                                "GSDP Estimates Report" ||
                                childItem.menuitemname_c ===
                                "GSDP Entry") && (
                                  <img
                                    src="../images/new1.gif"
                                    style={{
                                      marginLeft: "5px",
                                      width: "45px",
                                      height: "45px",
                                    }}
                                    alt="new"
                                  />
                                )}
                            </NavDropdown.Item>
                          )}
                        </div>
                      ))}
                    </NavDropdown>
                  ) : (
                    <Nav.Link
                      className="me-auto"
                      key={index}
                      href={
                        menuItem.menuitemname === "Home"
                          ? "/Menubar"
                          : menuItem.menuitemname === "Change Password"
                            ? "/ChangePassword"
                            : menuItem.targeturl
                      }
                      onClick={(e) => {
                        if (menuItem.menuitemname === "Home") {
                          e.preventDefault();
                          individualDashboardfun();
                        } else {
                          navigate(menuItem.targeturl);
                        }
                      }}
                    >
                      {menuItem.menuitemname === "Home" && (
                        <BsHouseFill className="mx-1 mb-1" style={{ fontSize: "14px" }} />
                      )}
                      {menuItem.menuitemname === "Change Password" && (
                        <AiFillLock className="mx-1 mb-1" style={{ fontSize: "14px" }} />
                      )}
                      {menuItem.menuitemname === "Logout" && (
                        <AiOutlineLogout className="mx-1 mb-1" onClick={handleLogOut} style={{ fontSize: "15px" }} />
                      )}
                      {menuItem.menuitemname === "Data Entry" && (
                        <AiOutlineForm className="mx-1 mb-1" style={{ fontSize: "15px" }} />
                      )}
                      {menuItem.menuitemname === "Reports" && (
                        <BsFillBarChartFill className="mx-1 mb-1" style={{ fontSize: "15px" }} />
                      )}
                      {menuItem.menuitemname === "Service" && (
                        <MdMiscellaneousServices className="mx-1 mb-1" style={{ fontSize: "15px" }} />
                      )}
                      {menuItem.menuitemname === "Security" && (
                        <MdOutlineSecurity className="mx-1 mb-1" style={{ fontSize: "15px" }} />
                      )}
                      {menuItem.menuitemname === "Dashboard" && (
                        <MdOutlineAutoGraph className="mx-1 mb-1" style={{ fontSize: "15px" }} />
                      )}
                      {menuItem.menuitemname === "Analytical Reports" && (
                        <TbDeviceAnalytics className="mx-1 mb-1" style={{ fontSize: "15px" }} />
                      )}

                      <span style={{ fontSize: "12px" }}> {menuItem.menuitemname} </span>
                    </Nav.Link>
                  )}
                </div>
              ))}
          </Navbar.Collapse>
          <div className="d-flex align-items-center ms-auto gap-3 me-2">
            {/* <div className="position-relative">
            <span style={{ cursor: "pointer" }} onClick={toggleHistory}>
              <img src="images/activity4.png" style={{ width: "24px" }} alt="activity" />
            </span>

            {showHistory && (
              <Card
                ref={historyRef}
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "360px",
                  zIndex: 1000,
                  backgroundColor: "#fff",
                  padding: "15px",
                  borderRadius: "12px",
                  boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
                }}
              >
                <h5 className="text-center fw-bold text-warning mb-2">History</h5>
                <p className="text-center fw-bold text-secondary mb-2">You have visited:</p>

                {history.length > 0 ? (
                  <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                    {history.map((note, index) => (
                      <div key={index} className="d-flex align-items-center justify-content-between px-2 py-1 border-bottom" style={{ cursor: "pointer", fontWeight: 500, color: "#4A3F35" }} onClick={() => handleNavigation(note)} onMouseEnter={() => setHoverIndex(index)} onMouseLeave={() => setHoverIndex(null)}>
                        <div className="d-flex align-items-center">
                          <FaCircle size={7} color="#8B6508" className="me-2" />
                          {note.name}
                        </div>
                        {hoverIndex === index && (
                          <FaTimes
                            size={14}
                            color="#8B6508"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              const updatedHistory = history.filter((_, i) => i !== index);
                              setHistory(updatedHistory);
                              localStorage.setItem("navHistory", JSON.stringify(updatedHistory));
                            }}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center text-warning p-2">No History Found</div>
                )}
              </Card>
            )}
          </div> */}
            {/* {ModEnb === true && ( */}
            {/* <div className="notification-wrapper">

  <div
    className="notification-icon"
    onClick={handleBellClick}
  >
    <img
      src="images/notification1.png"
      className="bell-icon"
      alt="notification"
    />

    {notifications.length > 0 && (
      <span className="notification-badge">
        {notifications.length}
      </span>
    )}
  </div>

  {showNotifications && (
    <Card className="notification-card" ref={notificationRef}>

      <div className="notification-header">
        Notifications
      </div>

      <div className="notification-body">

        {notifications.length > 0 ? (
          notifications.map((note, index) => (
            <div
              key={index}
              className="notification-item"
            >
              <div className="notification-item-icon">
                <FaHandPointRight />
              </div>

              <div className="notification-text">
                <div className="notification-title">
                  {note}
                </div>

               
              </div>
            </div>
          ))
        ) : (
          <div className="empty-notification">
            No new notifications
          </div>
        )}

      </div>
    </Card>
  )}

</div> */}
            {/* )} */}
            {/* <div className="position-relative">
                <span role="button" tabIndex={0} style={{ cursor: "pointer" }} onClick={handleBellClick}
                 onKeyDown={(e) => {if (e.key === "Enter" || e.key === " ") {handleBellClick();}}} >  
                   <img src="images/notification1.png" className="bell-icon" style={{ width: "22px" }} alt="notification" />
              {notifications.length > 0 && <span className="notification-badge">{notifications.length}</span>}
            </span>

            {showNotifications && (
              <Card className="notification-card" ref={notificationRef}>
                <h6 className="notification-heading" >Notifications</h6>
                {notifications.length > 0 ? (
                  notifications.map((note, index) => (
                    <div key={index} className="d-flex align-items-center p-2 notification-heading">
                      <FaHandPointRight className="me-2" /> {note}
                    </div>
                  ))
                ) : (
                  <div className="text-center notification-heading p-2">No new notifications</div>
                )}
              </Card>
            )}
          </div> */}

            {/* <div className="header-dropdown-setting" style={{ cursor: "pointer" }}
           onClick={handleLogOut} role="button" tabIndex={0} onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") { handleLogOut(); }}}>
          <b>
            <IoLogOutOutline fontSize={18} /> LOGOUT
          </b>
        </div> */}

            {ModEnb === false && (
              <div>
                <MuiButton
                  variant="contained"
                  sx={{
                    backgroundColor: "#3D6949",
                    color: "white",
                    border: "1px solid #fff",
                    borderRadius: "100px",
                  }}
                  size="small"
                  onClick={() => Switchenb()}
                >
                  <MdSwapHoriz style={{ fontSize: "20px" }} /> switch module
                </MuiButton>
              </div>
            )}
          </div>
        </Navbar>
        {/* {marqueeMessages.length > 0 && (
  <div className="marquee-bar">

   
    <div
      className="marquee-label"

      // className={`marquee-label ${labelExpanded ? "expanded" : ""}`}
      // onMouseEnter={() => setLabelExpanded(true)}
      // onMouseLeave={() => setLabelExpanded(false)}
    >
      <div className="marquee-label-dot"></div>
      <span className="marquee-label-text">
        <span style={{ fontSize: "15px" }}>
          📌 
          🔔
          </span> Notifications
      </span>
    </div>

    <div className="marquee-scroll-wrapper"
      ref={marqueeRef}
      onMouseDown={handleDragStart}
      onMouseMove={handleDragging}
      onMouseUp={handleDragEnd}
      onMouseLeave={handleDragEnd}
      onTouchStart={handleDragStart}
      onTouchMove={handleDragging}
      onTouchEnd={handleDragEnd}>
      <span
        className="marquee-scroll-text"
        style={{ animationPlayState: pausedIndex !== null ? "paused" : "running" }}
      >
        {marqueeMessages.map((msg, index) => (
          <span
            className={`marquee-item ${pausedIndex === `f${index}` ? "marquee-item--hovered" : ""}`}
            key={`first-${index}`}
            onMouseEnter={() => {
              setPausedIndex(`f${index}`);
              setWiggleIndex(`f${index}`);
              setTimeout(() => setWiggleIndex(null), 450);
            }}
            onMouseLeave={() => setPausedIndex(null)}
          >
            <span
              className={`marquee-icon ${wiggleIndex === `f${index}` ? "marquee-icon--wiggle" : ""}`}
            >
              <BsLightningChargeFill className="flash-icon" />
            </span>
            <span className="marquee-item-text">
              {msg.message || msg.notice || msg.text || msg}
            </span>
            <span className="marquee-separator">|</span>
          </span>
        ))}

        {marqueeMessages.map((msg, index) => (
          <span
            className={`marquee-item ${pausedIndex === `s${index}` ? "marquee-item--hovered" : ""}`}
            key={`second-${index}`}
            onMouseEnter={() => {
              setPausedIndex(`s${index}`);
              setWiggleIndex(`s${index}`);
              setTimeout(() => setWiggleIndex(null), 450);
            }}
            onMouseLeave={() => setPausedIndex(null)}
          >
            <span
              className={`marquee-icon ${wiggleIndex === `s${index}` ? "marquee-icon--wiggle" : ""}`}
            >
              <BsLightningChargeFill className="flash-icon" />
            </span>
            <span className="marquee-item-text">
              {msg.message || msg.notice || msg.text || msg}
            </span>
            <span className="marquee-separator">|</span>
          </span>
        ))}
      </span>
    </div>
  </div>
)} */}
        {localStorage.getItem("showNotificationBanner") === "true" && (
          <NotificationBanner
            marqueeMessages={JSON.parse(
              localStorage.getItem("marqueeList") || "[]",
            )}
          />
        )}
        {/* {marqueeMessages.length > 0 && (
  <div className="marquee-bar">
    <div className="marquee-label">
      📢 NOTICES
    </div>
    <div className="marquee-scroll-wrapper">
      <span className="marquee-scroll-text">

        
        {marqueeMessages.map((msg, index) => (
          <span key={`first-${index}`}>
            {msg.message || msg.notice || msg.text || msg}
            {index < marqueeMessages.length - 1 && (
              <span className="marquee-separator">|</span>
            )}
          </span>
        ))}

      
        <span className="marquee-gap"></span>

       
        {marqueeMessages.map((msg, index) => (
          <span key={`second-${index}`}>
            {msg.message || msg.notice || msg.text || msg}
            {index < marqueeMessages.length - 1 && (
              <span className="marquee-separator">|</span>
            )}
          </span>
        ))}

      </span>
    </div>
  </div>
)} */}
      </div>
      <Modal
        fade={false}
        className="newmodal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={addModal}
      >
        <Modal.Header>
          <Modal.Title className="text-center">Session Extension</Modal.Title>
          <span
            role="button"
            tabIndex={0}
            onClick={handleClose}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleClose();
              }
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
            style={{ cursor: "pointer", color: "white" }}
          >
            &#215;
          </span>
        </Modal.Header>
        <Modal.Body
          className="p-3 d-flex flex-column justify-content-center align-items-center"
          onKeyDown={handleKeyDown}
        >
          <div className="text-center">
            <img
              src="images/question.gif"
              style={{ width: "70px", marginBottom: "10px" }}
              alt="Warning Icon"
            />

            <p className="fw-bold" style={{ fontSize: "17px" }}>
              Do you wish to extend the session timeout?
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            className="conform"
            onClick={handleConfirmSessionExtension}
          >
            Extend Session
          </button>
          <button type="button" className="cancel" onClick={handleClose}>
            No
          </button>
        </Modal.Footer>
      </Modal>

      <AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />
      <Footer />

      <Modal
        fade={false}
        className="newmodal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showModal}
        onHide={null}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title></Modal.Title>
          <span
            onClick={handleClose1}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleClose1();
              }
            }}
            role="button"
            tabIndex={0}
            onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
            style={{ fontSize: "30px", cursor: "pointer", color: "white" }}
            className="me-1"
          >
            &#215;
          </span>
        </Modal.Header>

        <Modal.Body
          className="p-3 d-flex flex-column justify-content-center align-items-center"
          onKeyDown={handleKeyDown}
        >
          <div className="text-center">
            <img
              src="images/question.gif"
              style={{ width: "70px", marginBottom: "10px" }}
              alt="Warning Icon"
            />

            <p className="fw-bold" style={{ fontSize: "17px" }}>
              {" "}
              Are you sure you want to sign out?{" "}
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="conform" onClick={handleConfirm}>
            Yes
          </button>
          <button type="button" className="cancel" onClick={handleCancel}>
            No
          </button>
        </Modal.Footer>
      </Modal>

      {location.pathname === "/Menubar" && ModEnb && (
        <>
          <Container fluid style={{ width: "95%" }}>
            <div className="sa-title">
              {/* <h2>Module<span> Dashboard</span></h2> */}
              <div className="news-slider news-slider-gos">
                <h1 className="ms-0">
                  Module <span>Dashboard</span>
                </h1>
              </div>
            </div>
          </Container>

          <Container fluid style={{ width: "95%" }} className="mb-5">
            {moduleList?.map((item, i) => (
              <div key={i} className="mt-5">
                <div className="ui-cat">
                  <div className="ui-cat-tag">
                    <span className="amount">{item.module_name}</span>
                    <span className="r1"></span> <span className="r2"></span>{" "}
                    <span className="r3"></span>
                  </div>
                </div>
                <Row>
                  {item?.submoduleList?.map((item1, index) => {
                    const IconComponent = icons[index % icons.length];
                    const itemId = item1?.sub_module_id;
                    return (
                      // <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3} key={index}>

                      //   <div className="card1" style={{ cursor: "pointer", "--card-bg": "#ffb64d"}} onClick={() => Modulelogin(item1?.sub_module_id)}>
                      //     <div className="card-head">
                      //       <IconComponent size={25} /> {item1?.sub_module_name}
                      //     </div>
                      //     {/* <div className="card-desc">Card Descption Here</div> */}
                      //     <div className="go-corner">
                      //       <div className="go-arrow">
                      //         <FaArrowRightLong />
                      //       </div>
                      //     </div>
                      //   </div>

                      <Col
                        xs={12}
                        sm={12}
                        md={6}
                        lg={3}
                        xl={3}
                        xxl={3}
                        className="mb-3"
                      >
                        <div className="card card-body pcard d-none">
                          <div className="d-flex border-bottom mb-3 pb-3">
                            <div className="card-icon">
                              {(item1?.sub_module_id == "2" ||
                                item1?.sub_module_id == "3") && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="40"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="none"
                                      stroke="#fff"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      stroke-width="1.5"
                                      d="M5.18 15.296c-1.258.738-4.555 2.243-2.547 4.126c.982.92 2.074 1.578 3.448 1.578h7.838c1.374 0 2.467-.658 3.447-1.578c2.009-1.883-1.288-3.389-2.546-4.126a9.61 9.61 0 0 0-9.64 0M14 7a4 4 0 1 1-8 0a4 4 0 0 1 8 0m5.5.143V8m0-.857c-.723 0-1.36-.379-1.734-.954m1.734.954c.723 0 1.36-.379 1.734-.954M19.5 2.857c.723 0 1.36.379 1.734.954M19.5 2.857c-.723 0-1.36.379-1.734.954m1.734-.954V2M22 3.286l-.766.525M17 6.714l.766-.525M17 3.286l.766.525M22 6.714l-.766-.525m0-2.378c.22.34.35.75.35 1.189s-.13.849-.35 1.189M17.766 3.81c-.22.34-.35.75-.35 1.189s.13.849.35 1.189"
                                      color="#000"
                                    />
                                  </svg>
                                )}

                              {item1?.sub_module_id == "4" && (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="40"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fill="#fff"
                                    d="M14.5 2a.5.5 0 0 0 0 1h1.793L11.5 7.793L8.854 5.146a.5.5 0 0 0-.708 0l-5 5a.5.5 0 0 0 .708.708L8.5 6.207l2.646 2.647a.5.5 0 0 0 .708 0L17 3.707V5.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5zm1 7a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 1 0v-8a.5.5 0 0 0-.5-.5m-8 2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m3.5 2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0zm-8 1a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0z"
                                  />
                                </svg>
                              )}
                              {item1?.sub_module_id == "1" && (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="40"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fill="#fff"
                                    d="M14.5 2a.5.5 0 0 0 0 1h1.793L11.5 7.793L8.854 5.146a.5.5 0 0 0-.708 0l-5 5a.5.5 0 0 0 .708.708L8.5 6.207l2.646 2.647a.5.5 0 0 0 .708 0L17 3.707V5.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5zm1 7a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 1 0v-8a.5.5 0 0 0-.5-.5m-8 2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m3.5 2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0zm-8 1a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0z"
                                  />
                                </svg>
                              )}
                            </div>
                            <div className="card-title">
                              {item1?.sub_module_name}
                            </div>
                          </div>
                          <button
                            className="card-button btn btn-sm  d-inline text-center"
                            onClick={() => Modulelogin(item1?.sub_module_id)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="30"
                              height="30"
                              viewBox="0 0 32 32"
                            >
                              <path
                                fill="none"
                                stroke="#fff"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m22 6l8 10l-8 10m8-10H2"
                              />
                            </svg>
                          </button>
                        </div>

                        {/* <div className='module-card' onClick={() => Modulelogin(item1?.sub_module_id)}>
                        <div className='d-flex justify-content-between'>
                          <div>
                            <div className='card-icon mb-4'>
                              {(item1?.sub_module_id == "2" || item1?.sub_module_id == "3") && <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"><path fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5.18 15.296c-1.258.738-4.555 2.243-2.547 4.126c.982.92 2.074 1.578 3.448 1.578h7.838c1.374 0 2.467-.658 3.447-1.578c2.009-1.883-1.288-3.389-2.546-4.126a9.61 9.61 0 0 0-9.64 0M14 7a4 4 0 1 1-8 0a4 4 0 0 1 8 0m5.5.143V8m0-.857c-.723 0-1.36-.379-1.734-.954m1.734.954c.723 0 1.36-.379 1.734-.954M19.5 2.857c.723 0 1.36.379 1.734.954M19.5 2.857c-.723 0-1.36.379-1.734.954m1.734-.954V2M22 3.286l-.766.525M17 6.714l.766-.525M17 3.286l.766.525M22 6.714l-.766-.525m0-2.378c.22.34.35.75.35 1.189s-.13.849-.35 1.189M17.766 3.81c-.22.34-.35.75-.35 1.189s.13.849.35 1.189" color="#000" /></svg>}

                              {(item1?.sub_module_id == "4") && <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 20 20"><path fill="#fff" d="M14.5 2a.5.5 0 0 0 0 1h1.793L11.5 7.793L8.854 5.146a.5.5 0 0 0-.708 0l-5 5a.5.5 0 0 0 .708.708L8.5 6.207l2.646 2.647a.5.5 0 0 0 .708 0L17 3.707V5.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5zm1 7a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 1 0v-8a.5.5 0 0 0-.5-.5m-8 2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m3.5 2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0zm-8 1a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0z" /></svg>}
                              {(item1?.sub_module_id == "1") && <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 20 20"><path fill="#fff" d="M14.5 2a.5.5 0 0 0 0 1h1.793L11.5 7.793L8.854 5.146a.5.5 0 0 0-.708 0l-5 5a.5.5 0 0 0 .708.708L8.5 6.207l2.646 2.647a.5.5 0 0 0 .708 0L17 3.707V5.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5zm1 7a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 1 0v-8a.5.5 0 0 0-.5-.5m-8 2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m3.5 2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0zm-8 1a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0z" /></svg>}
                            </div>
                        
                            <p>{item1?.sub_module_name}</p>
                          </div>
                        
                          <button className='card-button btn btn-sm  d-inline text-center' >
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 32 32"><path fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m22 6l8 10l-8 10m8-10H2" /></svg>

                          </button>
                        
                        </div>
                      </div> */}

                        <div
                          className="module-card"
                          role="button"
                          tabIndex={0}
                          onClick={() => Modulelogin(item1?.sub_module_id)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              Modulelogin(item1?.sub_module_id);
                            }
                          }}
                        >
                          <div className="d-flex justify-content-between">
                            <div>
                              <div className="card-icon mb-4">
                                {(item1?.sub_module_id == "2" ||
                                  item1?.sub_module_id == "3") && (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="40"
                                      height="40"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        fill="none"
                                        stroke="#fff"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="1.5"
                                        d="M5.18 15.296c-1.258.738-4.555 2.243-2.547 4.126c.982.92 2.074 1.578 3.448 1.578h7.838c1.374 0 2.467-.658 3.447-1.578c2.009-1.883-1.288-3.389-2.546-4.126a9.61 9.61 0 0 0-9.64 0M14 7a4 4 0 1 1-8 0a4 4 0 0 1 8 0m5.5.143V8m0-.857c-.723 0-1.36-.379-1.734-.954m1.734.954c.723 0 1.36-.379 1.734-.954M19.5 2.857c.723 0 1.36.379 1.734.954M19.5 2.857c-.723 0-1.36.379-1.734.954m1.734-.954V2M22 3.286l-.766.525M17 6.714l.766-.525M17 3.286l.766.525M22 6.714l-.766-.525m0-2.378c.22.34.35.75.35 1.189s-.13.849-.35 1.189M17.766 3.81c-.22.34-.35.75-.35 1.189s.13.849.35 1.189"
                                        color="#000"
                                      />
                                    </svg>
                                  )}

                                {item1?.sub_module_id == "4" && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="40"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      fill="#fff"
                                      d="M14.5 2a.5.5 0 0 0 0 1h1.793L11.5 7.793L8.854 5.146a.5.5 0 0 0-.708 0l-5 5a.5.5 0 0 0 .708.708L8.5 6.207l2.646 2.647a.5.5 0 0 0 .708 0L17 3.707V5.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5zm1 7a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 1 0v-8a.5.5 0 0 0-.5-.5m-8 2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m3.5 2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0zm-8 1a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0z"
                                    />
                                  </svg>
                                )}

                                {item1?.sub_module_id == "1" && (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="40"
                                    height="40"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      fill="#fff"
                                      d="M14.5 2a.5.5 0 0 0 0 1h1.793L11.5 7.793L8.854 5.146a.5.5 0 0 0-.708 0l-5 5a.5.5 0 0 0 .708.708L8.5 6.207l2.646 2.647a.5.5 0 0 0 .708 0L17 3.707V5.5a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5zm1 7a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 1 0v-8a.5.5 0 0 0-.5-.5m-8 2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m3.5 2.5a.5.5 0 0 1 1 0v4a.5.5 0 0 1-1 0zm-8 1a.5.5 0 0 1 1 0v3a.5.5 0 0 1-1 0z"
                                    />
                                  </svg>
                                )}
                                {item1?.sub_module_id == "5" && (
                                  <RiUserStarLine size={40} />
                                )}
                              </div>

                              <p>{item1?.sub_module_name}</p>
                            </div>

                            <button className="card-button btn btn-sm d-inline text-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 32 32"
                              >
                                <path
                                  fill="none"
                                  stroke="#fff"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="m22 6l8 10l-8 10m8-10H2"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </Col>
                      // </Col>
                    );
                  })}
                </Row>
              </div>
            ))}
          </Container>
        </>
      )}
      {/* {location.pathname === "/Menubar"&& <Dashboard />} */}
      {location.pathname === "/Menubar" && !ModEnb && Id === 2 && <Dashboard />}

      {/* {location.pathname === "/Menubar" && !ModEnb && [3, 4].includes(Id) && <Dashboard />} */}
    </>
  );
}
